

exports.__esModule = true;
exports.$GamblingBlockCoolOffPeriod = undefined;

var _squid = require('squid');

require('./directive');

var $GamblingBlockCoolOffPeriod = exports.$GamblingBlockCoolOffPeriod = _squid.$ComponentRoute.extend('$GamblingBlockCoolOffPeriod', {
    path: 'gamblingBlockCoolOffPeriod',
    directive: 'xo-gambling-block-cool-off-period-page',
    titleContent: 'gamblingBlockCoolOffPeriod.heading',
    query: ['message'],
    trackingData: {
        templateName: 'gamblingBlockCoolOffPeriod.dust',
        pageGoal: 'Gambling Block Cool Off Period page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-gambling-block-cool-off-period',
                'pagename2': '%::fullpage-gambling-block-cool-off-period:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: []
});
angular.value("$GamblingBlockCoolOffPeriod", $GamblingBlockCoolOffPeriod);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-gambling-block-cool-off-period/route.js
// module id = ./pages/xo-gambling-block-cool-off-period/route.js
// module chunks = 0